import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { can } from '../lib/permissions';
import { Spinner } from './ui';

/**
 * Guards a route.
 *
 * `requires` is an RBAC permission code. An account without it is sent home
 * rather than shown a screen it cannot use — an administrator, for instance,
 * manages the system but does not observe in it.
 */
export default function ProtectedRoute({ children, requires }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <Spinner size={36} />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (requires && !can(user, requires)) return <Navigate to="/" replace />;

  return children;
}
